import cn from 'classnames';

import { calculateToastMargin } from './util/index.js';

export default function ToastWrapper({
  id,
  inline = false,
  position = 'top',
  align = 'left',
  light,
  children,
  isLeaving,
  index,
  variant,
  spacing = '4rem',
}) {
  const toastClasses = cn({
    light: light,
    'toast-leave': isLeaving,
    'toast-enter': !isLeaving,
    'lds-toast': true,
    [`lds-toast-theme-${variant}`]: true,
    [`lds-toast-position-${position}`]: true,
    [`lds-toast-align-${align}`]: true,
    inline: inline,
  });
  return (
    <div
      role="alert"
      aria-live="polite"
      id={id}
      style={inline ? {} : calculateToastMargin(index, position, spacing)}
      className={toastClasses}
    >
      {children}
    </div>
  );
}
